<script lang="ts">
  import { DueDateType } from "$src/domain/projects/details/PaymentSchedule";
  import { t } from "svelte-i18n";

  export let type: DueDateType;
</script>

{#if type == DueDateType.ManualDate}
  {$t("page.projects.detail.schedule.manual-date")}
{:else if type == DueDateType.AfterOrder}
  {$t("page.projects.detail.schedule.after-order")}
{:else if type == DueDateType.BeforeInstallation}
  {$t("page.projects.detail.schedule.before-installation")}
{:else if type == DueDateType.AfterInstallation}
  {$t("page.projects.detail.schedule.after-installation")}
{/if}
